export default __webpack_public_path__ + "32f57808324e5d4743c69e845a6fc3ce.jpg";